<div class="progress-overlay"></div>
<div class="progress-overlay-content" fxLayout="column" fxLayoutAlign="center center">
  <div class="progress-overlay-text" fxLayout="row" fxLayoutGap="10px">
    <mat-spinner [diameter]="25"></mat-spinner>
    <span>{{ progressValue | number: '1.0-0' }}%</span>
  </div>
  <mat-progress-bar class="overlay-progress-bar" mode="determinate" [value]="progressValue"></mat-progress-bar>
</div>
